import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  notepad: [],
  notePadStored: null,
  filingNotes: [],
  error: null,
  notesStored: null,
};

export default reducerFactory(initialState, {
  [types.PERSONAL_NOTES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    notepad: [],
    notePadStored: null,
  }),
  [types.PERSONAL_NOTES_REQUEST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    notepad: response.results,
    notePadStored: null,
  }),
  [types.PERSONAL_NOTES_REQUEST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    notepad: [],
    notePadStored: null,
  }),
  [types.FILING_NOTES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    filingNotes: [],
    notesStored: null,
  }),
  [types.FILING_NOTES_REQUEST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    filingNotes: response.results,
    notesStored: null,
  }),
  [types.FILING_NOTES_REQUEST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    filingNotes: [],
    notesStored: null,
  }),
  [types.PERSONAL_NOTES_STORE_PUT]: state => ({
    ...state,
    isLoading: true,
    error: null,
    notepad: [],
    notePadStored: null,
  }),
  [types.PERSONAL_NOTES_STORE_PUT_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    notePadStored: true,
    notepad: [...state.notepad, response],
  }),
  [types.PERSONAL_NOTES_STORE_PUT_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    notepad: [],
    notePadStored: false,
  }),
  [types.FILING_NOTES_STORE_PUT]: state => ({
    ...state,
    isLoading: true,
    error: null,
    notesStored: null,
    filingNotes: [],
  }),
  [types.FILING_NOTES_STORE_PUT_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    notesStored: true,
    filingNotes: response,
  }),
  [types.FILING_NOTES_STORE_PUT_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    notesStored: false,
    filingNotes: [],
  }),
  [types.PERSONAL_NOTES_STORE_POST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    notePadStored: null,
    notepad: [],
  }),
  [types.PERSONAL_NOTES_STORE_POST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    notePadStored: true,
    notepad: [...state.notepad, response],
  }),
  [types.PERSONAL_NOTES_STORE_POST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    notePadStored: false,
    notepad: [],
  }),
  [types.FILING_NOTES_STORE_POST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    notesStored: null,
    filingNotes: [],
  }),
  [types.FILING_NOTES_STORE_POST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    notesStored: true,
    filingNotes: [...state.filingNotes, response],
  }),
  [types.FILING_NOTES_STORE_POST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    notesStored: false,
    filingNotes: [],
  }),
  [types.FILING_NOTES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    filingNotes: [],
  }),
  [types.FILING_NOTES_REQUEST_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    filingNotes: response.results,
  }),
  [types.FILING_NOTES_REQUEST_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    filingNotes: [],
  }),
});
